module.exports = __webpack_public_path__ + "img/CIP360-logo.8c8c9fea.png";